export const createImageObject = () => {
  return new Image();
};
